import { sortBy } from 'lodash';
import i18next from 'i18next';
import React, { useEffect } from 'react';

import { Dropdown } from '@commons/utils/styledLibraryComponents';

const MAX_SELECTION = 5;

const RestaurantLimitedDropdown = ({ stores, selectedStores, setSelectedStores }) => {
  // Initialize stores (first N by default)
  useEffect(() => {
    if (stores && stores.length > 0) {
      setSelectedStores(sortBy(stores, 'name').slice(0, MAX_SELECTION));
    }
  }, [stores]);

  const handleStoreSelectionChange = (items) => {
    setSelectedStores(sortBy(items, 'name').slice(0, MAX_SELECTION));
  };

  return (
    <Dropdown
      customStyle={{ width: '300px' }}
      isUniqueSelection={false}
      items={stores}
      label={i18next.t('GENERAL.STORES')}
      maxSelection={MAX_SELECTION}
      searchPlaceholder={i18next.t('GENERAL.SEARCH')}
      selectedItems={selectedStores}
      onSelectionChange={handleStoreSelectionChange}
    />
  );
};

export default RestaurantLimitedDropdown;
